import usePrivateAxios from "@/common/api/usePrivateAxios"
import { EstablishmentLeadData, EstablishmentLeadResponse } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type"
import { UseQueryResult, useQuery } from "@tanstack/react-query"

export const useEstablishmentLead: (id: string) => UseQueryResult<EstablishmentLeadData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EstablishmentLeadResponse, unknown, EstablishmentLeadData>({
    queryKey: ['establishmentLead', id],
    queryFn: () => {
      return privateAxios.get(`funnel/establishment/leads/${id}`)
    },
    select: (data) => data?.data?.data
  })
}
